"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScreenAmountProfile = exports.ScreenAmountProfileProvider = void 0;
var screen_amount_profile_provider_1 = require("./screen-amount-profile-provider");
Object.defineProperty(exports, "ScreenAmountProfileProvider", { enumerable: true, get: function () { return screen_amount_profile_provider_1.ScreenAmountProfileProvider; } });
var screen_amount_profile_1 = require("./screen-amount-profile");
Object.defineProperty(exports, "ScreenAmountProfile", { enumerable: true, get: function () { return screen_amount_profile_1.ScreenAmountProfile; } });
//# sourceMappingURL=index.js.map